import { gql } from '@anyx/common-graphql';

export const GET_LINE_UNIT_MESSAGE = gql(/* GraphQL */ `
  query GetLineUnitMessage($input: FetchUnitMessageRequest!) {
    UnitMessage(input: $input) {
      id
      name
      content {
        ...LineMessageFields
      }
    }
  }
`);

export const DESERIALIZE_DRAFT_UNIT_MESSAGE = gql(/* GraphQL */ `
  query DeserializeDraftUnitMessage($input: DecodeDraftUnitMessageContentRequest!) {
    DecodeDraftUnitMessageContent(input: $input) {
      name
      content {
        ...LineMessageFields
      }
    }
  }
`);

export const SERIALIZE_DRAFT_UNIT_MESSAGE = gql(/* GraphQL */ `
  query SerializeDraftUnitMessage($input: GenerateDraftUnitMessageContentRequest!) {
    GenerateDraftUnitMessageContent(input: $input)
  }
`);

export const GET_LINE_RICH_MENU_SELECTOR_DIALOG_LIST = gql(/* GraphQL */ `
  query GetLineRichMenuSelectorDialogList($input: LineRichMenusInput!) {
    LineRichMenus(input: $input) {
      total
      records {
        id
        title
        imageUrl
      }
    }
  }
`);
